export default {
  common: {
    yes: 'Ha',
    no: "Yo'q",
    from: 'dan',
    list: "Ro'yxat",
    of: 'dan',
    all: 'Barchasi',
    active: 'Faol',
    inactive: "O'chirilgan",
    notFound: 'Topilmadi',
    loading: 'Yuklanmoqda...',
    noData: "Ma'lumot yo'q",
    searchPlaceholder: 'Nima qidiryapmiz...',
    profile: 'Profil',
    lpuWord: 'DTM',
    main: 'Asosiy',
    available: 'Mavjud',
    selected: 'Tanlangan',
    promotional: 'Aksiyali',
    total: 'Jami',
  },

  actions: {
    add: "Qo'shish",
    apply: "Qo'llash",
    save: 'Saqlash',
    remove: "O'chirish",
    update: "O'zgartirish",
    edit: 'Tahrirlash',
    filter: 'Filtr',
    close: 'Yopish',
    clear: 'Tozalash',
    choose: 'Tanlash',
    cancel: 'Bekor qilish',
    login: 'Kirish',
    logout: 'Chiqish',
    detail: 'Batafsil',
    object: 'Obyekt',
  },

  auth: {
    login: 'Login',
    loginPlaceholder: 'Sizning loginingiz',
    password: 'Parol',
    passwordPlaceholder: 'Sizning parolingiz',
    rememberMe: 'Meni eslab qol',
    forgotPassword: 'Parolni unutdingizmi?',
    signIn: 'Kirish',
    repeatPassword: 'Parolni takrorlang',
    oldPassword: 'Eski parol',
    newPassword: 'Yangi parol',
    repeatNewPassword: 'Yangi parolni takrorlang',
    passwordChanged: "Parol o'zgartirildi",
    fillAllFields: "Barcha maydonlarni to'ldiring.",
    passwordsDoNotMatch: 'Parollar mos kelmadi.',
    newPasswordSameAsOld: "Yangi parol eski parol bilan bir xil bo'lmasligi kerak.",
    oldPasswordIncorrect: "Eski parol noto'g'ri kiritildi",
  },

  notFound: {
    title: 'Siz izlagan sahifani topa olmayapmiz!',
    backToHome: 'Bosh sahifaga qaytish',
  },

  navigation: {
    main: 'Asosiy',
    news: 'Yangiliklar',
    dashboard: 'Analitika',
    stock: 'Zaxiralar',
    directories: "Ma'lumotnomalar",
    storeBalances: 'Ombordagi qoldiqlar',
    supplierContracts: 'Yetkazib beruvchilar bilan shartnomalar',
    storeIn: 'Tovarlarni qabul qilish',
    storeWriteOff: 'Zaxiralarni hisobdan chiqarish',
    storeCheck: 'Inventarizatsiya',
    storeChange: "Filiallararo ko'chirishlar",
    marketing: 'Marketing',
    promotions: 'Aksiyalar',
    organizations: 'Tashkilotlar',
    warehouses: 'Omborlar',
    cashes: 'Kassalar',
    regions: 'Hududlar',
    users: 'Foydalanuvchilar',
    roles: 'Rollar',
    metadata: 'Modullar',
    inventory: 'Tovarlar',
    profile: 'Profil',
    notifications: 'Bildirishnoma',
    allNotifications: 'Barcha bildirishnomalar',
    sales: 'Sotuvlar',
    orders: 'Buyurtmalar',
    customers: 'Xaridorlar',
    customerTypes: 'Xaridor turlari',
    customerGroups: 'Xaridor guruhlari',
    inventoryTypes: 'Tovar turlari',
    inventoryGroups: 'Tovar guruhlari',
    choisedItems: 'Tanlangan tovarlar',
    userType: 'Foydalanuvchi turi',
  },

  pages: {
    userProfile: 'Foydalanuvchi profili',
    listWarehouse: 'Omborlar',
    addWarehouse: "Ombor qo'shish",
    listUser: 'Foydalanuvchilar',
    listSupplierContract: 'Yetkazib beruvchilar bilan shartnomalar',
    listStoreWriteOff: 'Zaxiralarni hisobdan chiqarish',
    addStoreWriteOff: "Zaxiralarni hisobdan chiqarishni qo'shish",
    listStoreIn: 'Tovarlarni qabul qilish',
    listStoreCheck: 'Inventarizatsiya',
    addStoreCheck: "Inventarizatsiya qo'shish",
    listStore: 'Zaxiralar',
    listRole: 'Rollar',
    listRegion: 'Hududlar',
    addRegion: "Hudud qo'shish",
    listOrganization: 'Tashkilotlar',
    addOrganization: "Tashkilot qo'shish",
    listMetadata: 'Metadata',
    listInventory: 'Tovarlar',
    addInventory: "Tovar qo'shish",
    editInventory: 'Tovarni tahrirlash',
    listCash: 'Kassalar',
    addCash: "Kassa qo'shish",
    listStoreChange: "Filiallararo ko'chirishlar",
    addPromotion: "Aksiya qo'shish",
    addCustomer: "Xaridor qo'shish",
    listCustomer: "Xaridorlar ro'yxati",
    customerTypes: 'Xaridor turlari',
    groupContent: 'Guruh tarkibi',
    customerGroup: 'Xaridor guruhi',
    inventoryGroup: 'Tovar guruhi',
    inventoryTypes: 'Tovar turlari',
    addInventoryType: "Tovar turini qo'shish",
    addCustomerType: "Xaridor turini qo'shish",
    addCustomerGroup: "Xaridor guruhini qo'shish",
    inventoryGroups: 'Tovar guruhlari',
    customerGroups: 'Xaridor guruhlari',
    addInventoryGroup: "Tovar guruhini qo'shish",
    listCustomerType: 'Xaridor turlari',
    addPriceType: "Narx turini qo'shish",
    listPriceType: 'Narx turlari',
    addTelegramBotUser: "Telegram-bot foydalanuvchisini qo'shish",
    listTelegramBotUser: 'Telegram-bot foydalanuvchilari',
    addOrder: "Buyurtma qo'shish",
    editOrder: 'Buyurtmani tahrirlash',
    addInventories: "Tovarlar qo'shish",
    editCondition: 'Shartni tahrirlash',
    addStoreChange: "Filiallararo ko'chirishlarni qo'shish",
    addStoreInGoods: "Tovarlar qabulini qo'shish",
    addPurchases: "Xaridlarni qo'shish",
    purchases: 'Xaridlar',
    addDiscountMarkups: "Chegirma/ustama qo'shish",
    addReturn: "Qaytarishni qo'shish",
    order: 'Buyurtma',
    return: 'Qaytarish',
    returns: 'Qaytarishlar',
  },

  forms: {
    filter: 'Filtr',
    deletion: "O'chirish",
    deleteConfirm: "Siz haqiqatan ham bu obyektni o'chirmoqchimisiz?",
    status: 'Status',
    name: 'Ism',
    title: 'Nomi',
    description: 'Tavsif',
    date: 'Sana',
    number: 'Raqam',
    amount: 'Summa',
    price: 'Narx',
    quantity: 'Miqdor',
    inn: 'INN',
    organization: 'Tashkilot',
    warehouse: 'Ombor',
    supplierContract: 'Yetkazib beruvchi bilan shartnoma',
    supplier: 'Yetkazib beruvchi',
    inventory: 'Tovar',
    inventorySeries: 'Seriya',
    storeBalance: 'Ombordagi qoldiq',
    validFrom: 'Amal qilish muddati',
    expirationDate: 'Amal qilish muddati tugashi',
    deliveryDate: 'Yetkazib berish sanasi',
    deliveryDateShort: 'Yetkazish sanasi',
    packageQuantity: 'Qadoqdagi miqdor',
    language: 'Til',
    languageChanged: "Til o'zgartirildi",
    login: 'Login',
    pinfl: 'PINFL',
    fact: 'Fakt',
    balance: 'Qoldiq',
    position: 'Lavozim',
    start: 'Boshlanishi',
    end: 'Tugashi',
    cashPayment: 'Naqd pulda',
    transferPayment: "O'tkazma orqali",
    optional: 'Ixtiyoriy',
    minQuantity: 'Minimal miqdor',
    maxQuantity: 'Maksimal miqdor',
    minRequired: 'Majburiy minimum',
    note: 'Izoh',
    storeRemaining: "Ombor bo'yicha qoldiq",
    actualQuantity: "Fakt bo'yicha miqdor",
    fromOrganization: 'Tashkilotdan',
    fromWarehouse: 'Ombordan',
    toOrganization: 'Tashkilotga',
    toWarehouse: 'Omborga',
    inventoryType: 'Tovar turi',
    lastName: 'Familiya',
    middleName: 'Otasining ismi',
    customerType: 'Xaridor turi',
    birth: "Tug'ilgan kun",
    label: 'Nomi',
    alternativeName: 'Alternativ nomi',
    fiz: 'Jismoniy shaxs',
    yur: 'Yuridik shaxs',
    createDetails: 'Detal yaratish',
    latitude: 'Kenglik',
    longitude: 'Uzunlik',
    series: 'Seriya',
    passportNumber: 'Passport raqami',
    cardNumber: 'Plastik karta raqami',
    transitAccount: 'Tranzit hisob',
    settlementAccount: 'Hisob-kitob raqami',
    mfo: 'MFO',
    bank: 'Bank',
    editDetails: 'Detalni tahrirlash',
    promotionStart: 'Aksiya boshlanishi',
    promotionEnd: 'Aksiya tugashi',
    payment: "To'lov",
    promotionType: 'Aksiya turi',
    addCondition: "Shart qo'shish",
    bonuses: 'Bonuslar',
    promotionWarehouses: 'Aksiya omborlari',
    selectDate: 'Sanani tanlang',
    phone: 'Telefon',
    mainContract: 'Asosiy shartnoma',
    clientType: 'Mijoz turi',
    contractNumber: 'Kontrakt raqami',
    innPinfl: 'INN/PINFL',
    addDiscountsAndMarkups: "Chegirma va ustamalarni qo'shish",
    type: 'Turi',
    discount: 'Chegirma',
    markup: 'Ustama',
    calculationMethod: 'Hisoblash usuli',
    inPercent: 'Foizda',
    fixedAmount: 'Belgilangan summa',
    value: 'Qiymat',
    promotions: 'aksiyalar',
    expiryPeriod: 'Yaroqlilik muddati',
    paymentType: "To'lov turi",
    discountMarkup: 'Chegirma/ustama',
    totalAmount: 'Umumiy summa',
    discountMarkupAmount: 'Chegirma/ustama summasi',
    totalQuantity: 'Umumiy miqdor',
    orderAmount: 'Buyurtma summasi',
    discountPercent: 'Chegirma (%)',
    userTypes: 'Foydalanuvchi turlari',
    inventorySeriesFull: 'Tovar seriyasi',
    phoneNumber: 'Telefon raqami',
    discountMarkups: 'Chegirmalar va ustamalar',
    cash: 'Naqd pul',
    transfer: "O'tkazma",
    customer: 'Mijoz',
    region: 'Hudud',
    priceType: 'Narx turi',
    contract: 'Shartnoma',
    product: 'mahsulot',
    search: 'Qidiruv',
    createReturn: 'Qaytarish yaratish',
    addFullReturn: "To'liq qaytarish qo'shish",
    addPartialReturn: "Qisman qaytarish qo'shish",
    dateNumberReturn: 'Qaytarish raqami va sanasi',
    dateNumberOrder: 'Buyurtma raqami va sanasi',
    discountAmount: 'Buyurtma summasiga qarab chegirma',
    discountQuantity: "Miqdorga qo'shimcha",
    orderStatusDraft: 'Qoralama',
    orderStatusTest: 'Test',
    returnTypeFull: "To'liq qaytarish",
    returnTypeCustom: 'Ixtiyoriy qaytarish',
    returnTypePartial: 'Qisman qaytarish',
  },

  tables: {
    name: 'Nomi',
    nameAndSeries: 'Nomi va seriyasi',
    status: 'Status',
    dateAndNumber: 'Sana va raqam',
    organization: 'Tashkilot',
    warehouse: 'Ombor',
    supplierContract: 'Yetkazib beruvchi bilan shartnoma',
    login: 'Login',
    pinfl: 'PINFL',
    storeIn: 'Kirim',
    storeWriteOff: 'Hisobdan chiqarish',
    inventory: 'Tovar',
    inventorySeries: 'Seriya',
    quantity: 'Miqdor',
    balance: 'Qoldiq',
    fact: 'Fakt',
    applied: 'Bajarilishi',
    posted: 'Kirim qilingan',
    price: 'Narx',
    amount: 'Summa',
    deliveryDate: 'Yetkazish sanasi',
    validFrom: 'Amal qilish muddati',
    expirationDate: 'Amal qilish muddati tugashi',
    packageQuantity: 'Qadoqdagi miqdor',
    reserved: 'Bron',
    idAndStatus: 'ID va status',
    fromOrganizationAndWarehouse: 'Tashkilot va ombordan',
    toOrganizationAndWarehouse: 'Tashkilot va omborga',
    builtIn: 'Standart',
  },

  entities: {
    cash: 'Kassa',
    customer: 'Xaridor',
    detail: 'Detal',
    inventory: 'Tovar',
    inventoryItem: 'Tovar',
    inventorySeries: 'Seriya',
    metadata: 'Metadata',
    organization: 'Tashkilot',
    payment: "To'lov",
    region: 'Hudud',
    role: 'Rol',
    store: 'Zaxira',
    storeCheck: 'Inventarizatsiya',
    storeIn: 'Tovarlarni qabul qilish',
    storePosting: 'Kirim qilish',
    storePostingProduct: 'Tovarni kirim qilish',
    storeWriteOff: 'Zaxiralarni hisobdan chiqarish',
    supplierContract: 'Yetkazib beruvchi bilan shartnoma',
    supplierContractShort: 'Yetkazib beruvchi bilan kontrakt',
    user: 'Foydalanuvchi',
    warehouse: 'Ombor',
    condition: 'Shart',
    bonus: 'Bonus',
    shortage: 'Kamomad',
    surplus: 'Ortiqcha',
    object: 'Obyekt',
    contract: 'Kontrakt',
    priceType: 'Narx turi',
    telegramBotUser: 'Telegram foydalanuvchisi',
    customerContractEdit: 'Shartnomani tahrirlash',
    customerContractAdd: 'Shartnoma yaratish',
    medicalRepresentative: 'Savdo vakili',
  },

  tabs: {
    inventory: 'Tovar',
    details: 'Detallar',
    series: 'Seriya',
    storeIn: 'Tovarlarni qabul qilish',
    goods: 'Tovarlar',
    contract: 'Shartnoma',
    payments: "To'lovlar",
    permissions: 'Huquqlar',
    role: 'Rol',
    rolePermissions: 'Vakolatlar',
    shortage: 'Kamomadlar',
    surplus: 'Ortiqcha',
    inventoryGroup: 'Guruhlar',
    customerDetails: 'Rekvizitlar',
    customerRegions: 'Hududlar',
    customerGroups: 'Guruhlar',
    returnNumber: 'Qaytarish raqami',
    returnDate: 'Qaytarish sanasi',
    returnType: 'Qaytarish turi',
    orderNumber: 'Buyurtma raqami',
    orderDate: 'Buyurtma sanasi',
    promoInventories: 'Aksiyali tovarlar',
  },

  permissions: {
    read: "O'qish",
    create: 'Yaratish',
    update: 'Yangilash',
    delete: "O'chirish",
    userModules: 'Foydalanuvchi modullari',
    allModules: 'Barcha modullar',
  },

  messages: {
    success: 'Muvaffaqiyatli',
    successful: 'Muvaffaqiyatli',
    error: 'Xatolik',
    warning: 'Ogohlantirish',
    info: "Ma'lumot",
    delete: "O'chirilgan",
    created: '{message} muvaffaqiyatli yaratildi',
    deleted: "{message} muvaffaqiyatli o'chirildi",
    updated: "{message} muvaffaqiyatli o'zgartirildi",
    added: "{message} qo'shildi",
  },

  operations: {
    posting: 'Kirim qilish',
    post: 'Kirim qilish',
    cancelPosting: 'Kirim qilishni bekor qilish',
    postingConfirm: 'Siz haqiqatan ham omborga kirim qilmoqchimisiz?',
    cancelPostingConfirm: 'Siz haqiqatan ham omborga kirim qilishni bekor qilmoqchimisiz?',
    inventoryCheck: 'Inventarizatsiya',
    applyInventoryCheck: "Qo'llash",
    cancelInventoryCheck: "Qo'llashni bekor qilish",
    inventoryCheckConfirm: "Siz haqiqatan ham inventarizatsiyani qo'llamoqchimisiz?",
    cancelInventoryCheckConfirm:
      "Siz haqiqatan ham inventarizatsiyani qo'llashni bekor qilmoqchimisiz?",
    writeOff: 'Zaxiralarni hisobdan chiqarish',
    writeOffButton: 'Hisobdan chiqarish',
    cancelWriteOff: 'Hisobdan chiqarishni bekor qilish',
    writeOffConfirm: 'Siz haqiqatan ham ombordan hisobdan chiqarmoqchimisiz?',
    cancelWriteOffConfirm: 'Siz haqiqatan ham ombordan hisobdan chiqarishni bekor qilmoqchimisiz?',
    cancelWriteOffButton: 'Hisobdan chiqarishni bekor qilish',
    storeChangeConfirm: "Siz haqiqatan ham qo'llamoqchimisiz?",
    cancelStoreChangeConfirm: "Siz haqiqatan ham qo'llashni bekor qilmoqchimisiz?",
    writeOffTypoButton: 'Hisobdan chiqarish',
    postingLower: 'kirim qilish',
  },

  dashboard: {
    salesAndReturnsDynamics: "Vaqt oralig'i bo'yicha sotuv va qaytarishlar dinamikasi",
    customerGroupSales: "Xaridor guruhlari bo'yicha sotuvlar",
    ordersCountForPeriod: 'Davr uchun buyurtmalar soni',
    ordersAmountForPeriod: 'Davr uchun buyurtmalar summasi',
    returnsCountForPeriod: 'Davr uchun qaytarishlar soni',
    returnsAmountForPeriod: 'Davr uchun qaytarishlar summasi',
    selectedProductsShare: 'Tanlangan mahsulotlarning umumiy summadagi ulushi',
    name: 'Nomi',
    okb: 'OKB',
    akb: 'AKB',
    akbShare: 'AKB ulushi',
    ordersCount: 'Buyurtmalar soni',
    ordersAmount: 'Buyurtmalar summasi',
    returnsCount: 'Qaytarishlar soni',
    returnsAmount: 'Qaytarishlar summasi',
    salesShare: 'Sotuvlar ulushi',
    receipts: 'Tushumlar:',
    clientDebts: 'Mijozlar qarzdorligi:',
    index: 'Indeks',
    grossProfit: 'Yalpi foyda',
    thousand: 'ming',
    billion: 'mlrd',
  },

  promotion: {
    promotion: 'Aksiya',
    conditions: 'Shartlar',
    bonus: 'Bonus',
  },

  userRelations: {
    userUpdated: "Foydalanuvchi o'zgartirildi",
    userWarehouses: 'Foydalanuvchi omborlari',
    allWarehouses: 'Barcha omborlar',
    userRoles: 'Foydalanuvchi rollari',
    allRoles: 'Barcha rollar',
    userRegions: 'Foydalanuvchi hududlari',
    allRegions: 'Barcha hududlar',
    userOrganizations: 'Foydalanuvchi tashkilotlari',
    allOrganizations: 'Barcha tashkilotlar',
    userCashes: 'Foydalanuvchi kassalari',
    allCashes: 'Barcha kassalar',
  },

  profile: {
    settings: 'Profil sozlamalari',
    security: 'Xavfsizlik',
    changePasswordHint: "Parolni o'zgartirish uchun o'zgartirish tugmasini bosing.",
    title: "Foydalanuvchi qo'shish",
  },

  language: {
    ru: 'Rus tili',
    uz: "O'zbek tili",
  },

  notifications: {
    title: 'Bildirishnoma',
    all: 'Barcha bildirishnomalar',
    examples: {
      firstUser: 'Botir Zokirov',
      firstAction: "Mijoz to'lov qildi",
      firstProject: 'Dori - Eraton',
      firstType: 'Muxlis farm',
      secondUser: 'Jamshid Iskandarov',
      secondAction: "Debitorlik qarzi yana paydo bo'ldi",
      secondProject: 'Kretamin',
      secondType: 'Shayana farm',
      thirdUser: 'Oyposhsha Jurayeva',
      thirdAction: 'Ertaga sumalak',
      thirdProject: 'HR jamoa quruvchi',
      thirdType: 'Kadrlar',
    },
  },
}
